import type { LvdProductComplianceFileView } from '@/shared/hooks/api/lvdComplianceFiles'
import { LvdProductComplianceFileSignOffActions } from '@/v2/components/lvd/LvdProductComplianceFileSignOffActions'
import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'
import { V2LvdLegislationBriefingStepShell } from './V2LvdLegislationBriefingStepShell'

export function V2LvdProductSignOffStep({
  step,
  index,
  productId,
  productFile,
}: {
  step: LvdBriefingStep
  index: number
  productId: string
  productFile: LvdProductComplianceFileView | null
}) {
  return (
    <V2LvdLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        productFile != null ? (
          <LvdProductComplianceFileSignOffActions
            productId={productId}
            productFile={productFile}
          />
        ) : undefined
      }
    />
  )
}
